interface NameBasketPayload {
  basket_id: string
  name: string
}

export class NameBasketRequest {
  endpointUrl: URL
  data: NameBasketPayload
  method = 'POST' as const
  headers: HeadersInit = { 'Content-Type': 'application/json' }

  constructor(endpoint: string, basketId: string, name: string) {
    this.endpointUrl = new URL(endpoint + 'NameBasket/', window.location.href)
    this.data = {
      basket_id: basketId,
      name: name,
    }
  }
}
